import { render, staticRenderFns } from "./WxGuide.vue?vue&type=template&id=06810df8&scoped=true"
import script from "./WxGuide.vue?vue&type=script&lang=js"
export * from "./WxGuide.vue?vue&type=script&lang=js"
import style0 from "./WxGuide.vue?vue&type=style&index=0&id=06810df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06810df8",
  null
  
)

export default component.exports